import React, { type ReactElement, useEffect, useState } from "react";
import { graphql } from "gatsby";
import { useI18next } from "gatsby-plugin-react-i18next";

import AppDownloadSection from "@components/app_download_section";
import Awards from "@components/awards";
import Faq from "@components/faq";
import GeoLocationList from "@components/geo_location_list";
import HeroSection from "@components/hero_section";
import HowItWorks from "@components/how_works";
import MobileMenu from "@components/mobile_menu";
import Seo from "@components/seo";
import { usePageEvent } from "@hooks/usePageEvent";
import { useConfigurationState } from "@stores/configuration";
import { usePaymentState } from "@stores/payment";

const StorePage = (): ReactElement => {
  usePageEvent("store");

  const { t, language } = useI18next();

  const paymentState = usePaymentState();
  const configurationState = useConfigurationState();
  const [isSSR, setSSR] = useState<boolean>(true);
  useEffect(() => {
    paymentState.clear();
    configurationState.resetLastVisitedRoute();
    setSSR(false);
  }, []);

  const Features = React.lazy(async () => await import("@components/features"));
  const Reviews = React.lazy(async () => await import("@components/reviews"));

  return (
    <>
      <Seo
        title={t("og_title") ?? ""}
        description={t("og_description") ?? ""}
        lang={language}
      />
      <HeroSection />
      <GeoLocationList />
      <div className="container">
        <HowItWorks />
        <AppDownloadSection />
        {!isSSR && (
          <React.Suspense fallback={<div />}>
            <Features />
            <Reviews />
          </React.Suspense>
        )}
        <Faq />
        <Awards />
        <MobileMenu />
      </div>
    </>
  );
};

export default StorePage;

export const query = graphql`
  query {
    locales: allLocale {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
